import { Button, DialogContent, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./Popup.module.css";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { X, Check } from "react-feather";
import { NumericFormat } from "react-number-format";
import { authData } from "../GetAuth";
import { CacheSetItem, STORAGE_KEYS } from "../StorageComp";
import { Close } from "@mui/icons-material";
import { CountryList } from "../Constants";
import { usePlacesWidget } from "react-google-autocomplete";

const AddCompanyForm = ({ setFormOpen, onLocal, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      tax_title: "Tax",
      pickup_country: "",
      delivery_country: "",
    },
  });

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_MAP_API_KEY,
    onPlaceSelected: (place) => {
      setValue("company_address", place.formatted_address);
    },
    options: {
      types: ["address"],
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("company_name", editData?.company_name);
      setValue("url_token", editData?.url_token);
      setValue("company_address", editData?.company_address);
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      setValue("tax_title", editData?.tax_title);
      setValue("pickup_country", editData?.pickup_country);
      setValue("delivery_country", editData?.delivery_country);
      setValue("reference_amount", editData?.reference_amount);
      setValue("reg_number", editData?.reg_number);
      setValue("vat_number", editData?.vat_number);
      setValue("payment_receiver_name", editData?.payment_receiver_name);
      setValue("payment_receiver_account", editData?.payment_receiver_account);
      setValue("payment_receiver_code", editData?.payment_receiver_code);
      setValue("tax_title", editData?.tax_title);
      setValue("reference_amount", editData?.reference_amount);
      setValue("terms_condition", editData?.terms_condition);

      if (editData?.tax_charges > 0)
        setValue("tax_charges", editData?.tax_charges);
      if (editData?.insurance_charges > 0)
        setValue("insurance_charges", editData?.insurance_charges);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/companies/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          onLocal(response.data.data);

          CacheSetItem(STORAGE_KEYS.WEBSITE, response.data.data, 15 * 60 * 1000);
        }

        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/companies", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          onLocal(response.data.data);
        }

        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  }

  const onError = (err) => {
    console.log(err);
  }

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      Update Company
      <IconButton onClick={(e) => setFormOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className={`${styles.FormMainRow}`}>
          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="company_name"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Company Name*" variant="outlined" fullWidth />)}
            />
            {errors.company_name && (<span className={`${styles.ErrorM}`}>{errors?.company_name?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="url_token"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Domain*" variant="outlined" fullWidth InputProps={{ endAdornment: (<InputAdornment position="end">.{process.env.REACT_APP_BASE_DOMAIN}</InputAdornment>) }} />)}
            />
            {errors.url_token && (<span className={`${styles.ErrorM}`}>{errors?.url_token?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="company_address"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" fullWidth inputRef={ref} placeholder="" />)}
            />
            {errors.company_address && (<span className={`${styles.ErrorM}`}>{errors?.company_address?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Owner Name*" variant="outlined" fullWidth />)}
            />
            {errors.name && (<span className={`${styles.ErrorM}`}>{errors?.name?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "This field is Required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              }}
              render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" fullWidth />)}
            />
            {errors.email && (<span className={`${styles.ErrorM}`}>{errors?.email?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="phone"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" fullWidth />)}
            />
            {errors.phone && (<span className={`${styles.ErrorM}`}>{errors.phone.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="reg_number"
              control={control}
              render={({ field }) => (<TextField {...field} label="Register No" variant="outlined" fullWidth />)}
            />
            {errors.reg_number && (<span className={`${styles.ErrorM}`}>{errors?.reg_number?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="vat_number"
              control={control}
              render={({ field }) => (<TextField {...field} label="Vat Number" variant="outlined" fullWidth />)}
            />
            {errors.vat_number && (<span className={`${styles.ErrorM}`}>{errors?.vat_number?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="payment_receiver_name"
              control={control}
              render={({ field }) => (<TextField {...field} label="Payment Receiver Name" variant="outlined" fullWidth />)}
            />
            {errors.payment_receiver_name && (<span className={`${styles.ErrorM}`}>{errors?.payment_receiver_name?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="payment_receiver_account"
              control={control}
              render={({ field }) => (<TextField {...field} label="Payment Receiver Account" variant="outlined" fullWidth />)}
            />
            {errors.payment_receiver_account && (<span className={`${styles.ErrorM}`}>{errors?.payment_receiver_account?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="payment_receiver_code"
              control={control}
              render={({ field }) => (<TextField {...field} label="Payment Receiver Code" variant="outlined" fullWidth />)}
            />
            {errors.payment_receiver_code && (<span className={`${styles.ErrorM}`}>{errors?.payment_receiver_code?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="tax_title"
              control={control}
              rules={{ required: "This field is Required" }}
              render={({ field }) => (<TextField {...field} label="Tax Title*" variant="outlined" fullWidth />)}
            />
            {errors.tax_title && (<span className={`${styles.ErrorM}`}>{errors?.tax_title?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="tax_charges"
              control={control}
              render={({ field }) => (<NumericFormat {...field} label="Tax Charges(%)" variant="outlined" customInput={TextField} fullWidth allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
            />
            {errors.tax_charges && (<span className={`${styles.ErrorM}`}>{errors?.tax_charges?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="insurance_charges"
              control={control}
              render={({ field }) => (<NumericFormat {...field} label="Insurance Charges" variant="outlined" customInput={TextField} fullWidth allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
            />
            {errors.insurance_charges && (<span className={`${styles.ErrorM}`}>{errors?.insurance_charges?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="pickup-country-label">Pickup Country*</InputLabel>
              <Controller
                name="pickup_country"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <Select {...field} labelId="pickup-country-label" label="Pickup Country*">
                    <MenuItem value={"GB"}>United Kingdom</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
            {errors.pickup_country && (<span className={`${styles.ErrorM}`}>{errors?.pickup_country?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <FormControl fullWidth>
              <InputLabel id="delivery-country-label">Delivery Country*</InputLabel>
              <Controller
                name="delivery_country"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <Select {...field} labelId="delivery-country-label" label="Delivery Country*">
                    {CountryList?.map((i) => (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>))}
                  </Select>
                )}
              />
            </FormControl>
            {errors.delivery_country && (<span className={`${styles.ErrorM}`}>{errors?.delivery_country?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupHalf}`}>
            <Controller
              name="reference_amount"
              control={control}
              render={({ field }) => (<NumericFormat {...field} label="Reference Amount" variant="outlined" customInput={TextField} fullWidth allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
            />
            {errors.reference_amount && (<span className={`${styles.ErrorM}`}>{errors?.reference_amount?.message}</span>)}
          </div>

          <div className={`${styles.FormGroupFull}`}>
            <Controller
              name="terms_condition"
              control={control}
              render={({ field }) => (<TextField {...field} label="Terms & Condition" variant="outlined" fullWidth multiline minRows={4} />)}
            />
            {errors.terms_condition && (<span className={`${styles.ErrorM}`}>{errors?.terms_condition?.message}</span>)}
          </div>
        </div>

        <div className={styles.ButtonAction}>
          <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpen(false)}>Cancel</Button>
          <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Update</Button>
        </div>
      </form>
    </DialogContent>
  </>);
};

export default AddCompanyForm;